import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type Props = {
  label: string;
  subline?: string;
  variant?: 'primary' | 'light';
  className?: string;
};
export function CTAButton({
  label,
  subline,
  variant = 'primary',
  className = ''
}: Props) {
  const base = 'group inline-flex w-full max-w-xl items-center justify-center gap-2 rounded-2xl px-5 py-4 text-center font-display text-base font-extrabold uppercase tracking-wide shadow-lg transition-[transform,background-color,box-shadow] duration-200 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-500 active:scale-[0.985] sm:text-lg';
  const styles = variant === 'light' ? 'bg-white text-navy-800 hover:bg-navy-50' : 'bg-sky-500 text-white hover:bg-sky-600';
  return <div className={`flex w-full flex-col items-center ${className}`} data-id="element-30" data-mp="3cnhsmo4hvgb9">
      <a href={CHECKOUT_URL} className={`${base} ${styles}`} data-id="element-31" data-mp="38ptvrfj8rdgq">
        <span data-id="element-32" data-mp="199eq8wm8n8p6">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-33" data-mp="19a7v1s1mzo4o" />
      </a>
      {subline ? <p className={`mt-3 text-center text-xs font-medium sm:text-sm ${variant === 'light' ? 'text-navy-200' : 'text-navy-500'}`} data-id="element-34" data-mp="1i8t8x9w5yez4">
          {subline}
        </p> : null}
    </div>;
}